import React from 'react';
import classNames from 'classnames';

/**
 * @typedef {{ label: string, bg: string }} Environment
 * @typedef {{ match: (host: string) => boolean, env: Environment }} Rule
 */

/** @type {Rule[]} */
const RULES = [
  {
    match: (h) => h === 'localhost' || h === '127.0.0.1' || h === '::1',
    env: { label: 'local', bg: 'bg-cs-yellow-500' },
  },
  {
    match: (h) => h === 'app-staging.communityshare.org',
    env: { label: 'staging', bg: 'bg-cs-orange-500' },
  },
  {
    match: (h) => h === 'app-staging-next.communityshare.org',
    env: { label: 'staging+', bg: 'bg-cs-orange-800' },
  },
  {
    match: (h) => h === 'app-next.communityshare.org',
    env: { label: 'prod+', bg: 'bg-cs-purple-500' },
  },
];

/**
 * @param {{ className?: string }} props
 */
export default function EnvironmentBadge({ className }) {
  // Determine environment label and bg color based on host
  const host = typeof window !== 'undefined' ? window.location.hostname : '';

  const env = RULES.find((r) => r.match(host))?.env ?? null;

  if (!env) return null;

  return (
    <span
      className={classNames(
        env.bg,
        'text-white w-fit p-3 items-center justify-center rounded-lg text-xs h-6 inline-flex',
        className
      )}
    >
      {env.label}
    </span>
  );
}
